import { useState } from 'react';
import { HelpCircle } from 'lucide-react';
import { HelpModal } from './HelpModal';
import { useClientDataContext } from '../contexts/ClientDataContext';

export function HelpButton() {
  const [showHelpModal, setShowHelpModal] = useState(false);
  const { clientData } = useClientDataContext();

  return (
    <>
      <button
        onClick={() => setShowHelpModal(true)}
        className="w-10 h-10 rounded-full bg-blue-600 hover:bg-blue-700 text-white shadow-lg hover:shadow-xl transition-all focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 flex items-center justify-center"
        aria-label="Open Help & Contact"
        title="Help & Contact"
      >
        <HelpCircle className="w-5 h-5" aria-hidden="true" />
      </button>

      <HelpModal
        isOpen={showHelpModal}
        onClose={() => setShowHelpModal(false)}
        clientData={clientData}
      />
    </>
  );
}
